module.exports = __webpack_public_path__ + "static/text2-6844e162031b286ef95a1229216fe2bb.svg";